import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios"

import { BookingPayloadType } from "./types"

export interface BookingRequest extends Partial<AxiosRequestConfig> {
  params: BookingPayloadType
}

export interface BookingResponseData {
  bookingNo: string
  clientSecret: string
  pmsType: string
  status: number
  bookingTotalAmount: number
}

export interface BookingResponse extends AxiosResponse {
  data: BookingResponseData
}

export function attemptBookingApi(
  { params }: BookingRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data: params,
    method: "post",
    url: "/booking",
  }) as Promise<BookingResponse>
}
